import * as Yup from 'yup'
import axios from 'axios';

import debounce from 'lodash.debounce';
// import { getItem, getLoginToken, removeLoginToken } from '../utils/localStorage'
import { getItem, getLoginToken, removeLoginToken } from '../../../utils/storageUtils'


const { REACT_APP_API_URL } = process.env;

// / 1. REMOVE debounce from your API function - make it a simple async function
export const checkUsernameAvailability = async (username, currentUserId = null) => {
  try {
    console.log('API call started for username:', username);
    
    const { data } = await axios.get(
      `${REACT_APP_API_URL}/api/admin/profile/checkUserName?adminUsername=${username}`,
      {
        headers: {
          Authorization: `Bearer ${getLoginToken()}`,
          'Content-Type': 'application/json',
        },
      }
    );
    
    console.log(data, "API response for username availability");
    
    // Return a consistent format
    return {
      available: data.data?.status, // true = available, false = taken
      message: data.data?.status ? 'Username is available!' : 'Username already exists'
    };
  } catch (error) {
    console.error('Username check failed:', error);
    return {
      available: false,
      message: 'Error checking username availability'
    };
  }
};






export const createStaffSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'Please enter a valid email address'
    )
    .max(200, 'Email must be less than 200 characters')
    .required('Email is required'),

  password: Yup.string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      'Password must contain at least 8 characters with 1 uppercase, 1 lowercase, 1 number and 1 special character'
    )
    .max(50, 'Password must be less than 50 characters')
    .required('Password is required'),

  firstName: Yup.string()
    .min(3, 'First name must be at least 3 characters')
    .max(20, 'First name must be less than 20 characters')
    .matches(/^[a-zA-Z]+(\s[a-zA-Z]+)?$/, 'First name can only contain letters and spaces')
    .required('First name is required'),

  lastName: Yup.string()
    .min(3, 'Last name must be at least 3 characters')
    .max(20, 'Last name must be less than 20 characters')
    .matches(/^[a-zA-Z]+(\s[a-zA-Z]+)?$/, 'Last name can only contain letters and spaces')
    .required('Last name is required'),

  role: Yup.string()
    .required('Role is required')
    .test('not-empty', 'Please select a role', (value) => value && value.trim() !== '')
    .nullable(),

  adminId: Yup.string().when('role', {
    is: 'Staff',
    then: () => Yup.string()
      .required('Manager selection is required')
      .test('not-empty', 'Please select a manager', (value) => value && value.trim() !== ''),
    otherwise: (schema) => schema.when('role', {
      is: 'Manager',
      then: () => Yup.string()
        .required('Admin selection is required')
        .test('not-empty', 'Please select an admin', (value) => value && value.trim() !== ''),
      otherwise: () => Yup.string().nullable()
    })
  }),

  adminUsername: Yup.string()
    .matches(/^[A-Za-z]+$/, 'Username can only contain letters')
    .min(8, 'Username must be at least 8 characters')
    .max(100, 'Username must be less than 100 characters')
    .required('Username is required'),


  group: Yup.string()
    .min(3, 'Group name must be at least 3 characters')
    .max(200, 'Group name must be less than 200 characters')
    .matches(/^[A-Za-z0-9 ]+$/, 'Group name can only contain letters, numbers and spaces')
    .required('Group is required')
    .test('not-empty', 'Please select or create a group', (value) => value && value.trim() !== ''),

  phoneCode: Yup.string()
    .required('Phone code is required'),

  phone: Yup.string()
    .matches(/^[0-9]+$/, 'Phone number can only contain digits')
    .min(6, 'Phone number must be at least 6 digits')
    .max(10, 'Phone number must be at most 10 digits')
    .required('Phone number is required'),

  countryCode: Yup.string()
    .required('Country code is required')
})

export const updateStaffSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'Please enter a valid email address'
    )
    .max(200, 'Email must be less than 200 characters')
    .required('Email is required'),

  password: Yup.string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      'Password must contain at least 8 characters with 1 uppercase, 1 lowercase, 1 number and 1 special character'
    )
    .max(50, 'Password must be less than 50 characters'),

  firstName: Yup.string()
    .min(3, 'First name must be at least 3 characters')
    .max(20, 'First name must be less than 20 characters')
    .matches(/^[a-zA-Z]+(\s[a-zA-Z]+)?$/, 'First name can only contain letters and spaces')
    .required('First name is required'),

  lastName: Yup.string()
    .min(3, 'Last name must be at least 3 characters')
    .max(20, 'Last name must be less than 20 characters')
    .matches(/^[a-zA-Z]+(\s[a-zA-Z]+)?$/, 'Last name can only contain letters and spaces')
    .required('Last name is required'),

  role: Yup.string()
    .required('Role is required')
    .test('not-empty', 'Please select a role', (value) => value && value.trim() !== ''),

  adminId: Yup.string().when('role', {
    is: 'Staff',
    then: () => Yup.string()
      .required('Manager selection is required')
      .test('not-empty', 'Please select a manager', (value) => value && value.trim() !== ''),
    otherwise: (schema) => schema.when('role', {
      is: 'Manager',
      then: () => Yup.string()
        .required('Admin selection is required')
        .test('not-empty', 'Please select an admin', (value) => value && value.trim() !== ''),
      otherwise: () => Yup.string().nullable()
    })
  }),

  adminUsername: Yup.string()
  .matches(/^[A-Za-z]+$/, 'Username can only contain letters')
  .min(8, 'Username must be at least 8 characters')
  .max(100, 'Username must be less than 100 characters')
  .required('Username is required'),

 

  group: Yup.string()
    .min(3, 'Group name must be at least 3 characters')
    .max(200, 'Group name must be less than 200 characters')
    .matches(/^[A-Za-z0-9 ]+$/, 'Group name can only contain letters, numbers and spaces')
    .required('Group is required')
    .test('not-empty', 'Please select or create a group', (value) => value && value.trim() !== ''),

  phoneCode: Yup.string()
    .required('Phone code is required'),

  phone: Yup.string()
    .matches(/^[0-9]+$/, 'Phone number can only contain digits')
    .min(6, 'Phone number must be at least 6 digits')
    .max(10, 'Phone number must be at most 10 digits')
    .required('Phone number is required'),

  countryCode: Yup.string()
    .required('Country code is required')
})
